export default function Section6() {
  return (
    <div className="Section6 px-[20px] md:px-[30px] my-[4%] md:my-0 md:mt-[68px]">
      <div className="section6-container md:flex md:justify-evenly md:items-center">
        <div className="mb-5 md:mb-0 md:w-[36%]">
          <h2 className="md:text-[34px] font-bold my-[0.67em] text-[24px] leading-[32px] md:leading-[41px] text-[#DA2128] pb-[2%]">
            Ready to Elevate Your Marketing?
          </h2>

          <p className="pb-[1%] mb-5 leading-[20px] text-[16px] font-open text-[#373737]">
            If you're ready to supercharge your marketing efforts and achieve
            real, measurable results, Reach us out today to schedule a
            consultation. Let's work together to develop a performance marketing
            strategy that propels your business forward.
          </p>

          <div className="btn-cont">
            <a href="https://mean3.com/contact-mean3/" className="bg-[#DA2128] text-white rounded-[3px] inline-block p-[10px_15px] text-[14px] font-bold leading-[1.15]">
              Get Started
            </a>
          </div>
        </div>

        <div className="w-full image-cont md:w-auto">
          <img
            className="w-full md:w-auto"
            src="../../../../assets/artboard2-performance-marketing.png"
          ></img>
        </div>
      </div>

      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
